import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Button, Box, Grid, useTheme } from '@mui/material';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { es } from 'date-fns/locale';
import { FormProvider, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { InputField } from './InputField.jsx';

export const FormDynamic = (props) => {
  const theme = useTheme();
  const location = useLocation();
  const formMethods = useForm();
  const { control, handleSubmit, setValue, formState, register, reset } = useForm({
    mode: 'onBlur',
  });
  const [loadView, setLoadView] = useState(false); //Se muestra/oculta el gif loader
  const [questions, setQuestions] = useState([]);
  const { t } = useTranslation();

  useEffect(() => {
    if (props.DataControls != undefined && props.DataControls != null) {
      setQuestions([]);
      console.log('new json props.DataControls : ', props.DataControls);
      setQuestions(props.DataControls);
    }
  }, [props.DataControls]);

  useEffect(() => {
    // console.log("props.RessetForm*****************", props.RessetForm)
    if (props.RessetForm == true) {
      props.setRessetForm(null);
      reset();
      // HandleChangeValues()
    }
  }, [props.RessetForm]);

  // useEffect(() => {
  //     // console.log("questions*****************", questions)
  //     if (questions.length > 0) {
  //         HandleChangeValues()
  //     }
  // }, [questions])

  // let HandleChangeValues = () => {
  //     // questions?.forEach(itemQuestion => {
  //     //     console.log("itemQuestion: ", itemQuestion)
  //     //     setValue(itemQuestion.Id, itemQuestion?.Value)
  //     // })
  // }
  return (
    <FormProvider {...formMethods} theme={theme}>
      <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={es}>
        <Box
          sx={{
            display: 'flex !important',
            flexDirection: 'column !important',
            position: 'relative',
            width: '100% !important',
            padding: 1,
            overflow: 'auto',
          }}
        >
          {questions.length > 0 && (
            <Box
              sx={(theme) => ({
                display: 'flex !important',
                flexDirection: 'column !important',
                alignItems: 'flex-start !important',
                position: 'relative',
                width: '100% !important',
                padding: 2,
                overflowY: 'hidden',
                [theme.breakpoints.only('xs')]: {
                  minHeight: props.minHeight ?? 'calc(100vh - 380px)',
                },
                [theme.breakpoints.only('sm')]: {
                  minHeight: props.minHeight ?? 'calc(100vh - 280px)',
                },
                [theme.breakpoints.only('md')]: {
                  minHeight: props.minHeight ?? 'calc(100vh - 280px)',
                },
                [theme.breakpoints.only('lg')]: {
                  minHeight: props.minHeight ?? 'calc(100vh - 280px)',
                },
                [theme.breakpoints.only('xl')]: {
                  minHeight: props.minHeight ?? 'calc(100vh - 280px)',
                },
              })}
            >
              {questions?.map((itemInput, index) => {
                switch (itemInput.DataType.toUpperCase()) {
                  case 'PHONE':
                    return (
                      <InputField
                        inputType="phone"
                        control={control}
                        register={register}
                        name={`${itemInput.Id}`}
                        label={itemInput.Description}
                        validations={{ required: itemInput.Required }}
                        defaultValue={itemInput.Value}
                        error={!!formState.errors[`${itemInput.Id}`]}
                        helperText={formState.errors[`${itemInput.Id}`]?.message}
                        required={itemInput.Required}
                      />
                    );
                  case 'RADIO':
                    return (
                      <InputField
                        inputType="radio"
                        control={control}
                        register={register}
                        name={`${itemInput.Id}`}
                        label={itemInput.Description}
                        radioValues={itemInput.Options}
                        required={itemInput.Required}
                        validations={{ required: true }}
                        defaultValue={itemInput.Value}
                        error={!!formState.errors[`${itemInput.Id}`]}
                        helperText={formState.errors[`${itemInput.Id}`]?.message}
                      />
                    );
                  case 'COMBO':
                    return (
                      <InputField
                        inputType="select"
                        control={control}
                        register={register}
                        name={`${itemInput.Id}`}
                        label={itemInput.Description}
                        optionsList={itemInput.Options}
                        validations={{ required: itemInput.Required }}
                        defaultValue={itemInput.Value}
                        error={!!formState.errors[`${itemInput.Id}`]}
                        helperText={formState.errors[`${itemInput.Id}`]?.message}
                        required={itemInput.Required}
                      />
                    );
                  case 'DATE':
                    return (
                      <InputField
                        inputType="date"
                        register={register}
                        control={control}
                        name={`${itemInput.Id}`}
                        label={itemInput.Description}
                        validations={{ required: itemInput.Required }}
                        error={!!formState.errors[`${itemInput.Id}`]}
                        helperText={formState.errors[`${itemInput.Id}`]?.message}
                        required={itemInput.Required}
                        defaultValue={''}
                      />
                    );
                  case 'CHECKBOX':
                    return (
                      <InputField
                        inputType="check"
                        control={control}
                        register={register}
                        name={`${itemInput.Id}`}
                        label={itemInput.Description}
                        validations={{ required: true }}
                        defaultValue={itemInput.Value}
                        error={!!formState.errors[`${itemInput.Id}`]}
                        helperText={formState.errors[`${itemInput.Id}`]?.message}
                        required={itemInput.Required}
                      />
                    );
                  case 'CURRENCY':
                    return (
                      <InputField
                        inputType="currency"
                        control={control}
                        register={register}
                        name={`${itemInput.Id}`}
                        label={itemInput.Description}
                        validations={{ required: itemInput.Required }}
                        defaultValue={itemInput.Value}
                        error={!!formState.errors[`${itemInput.Id}`]}
                        helperText={formState.errors[`${itemInput.Id}`]?.message}
                        required={itemInput.Required}
                      />
                    );
                  case 'EMAIL':
                    return (
                      <InputField
                        inputType="email"
                        control={control}
                        register={register}
                        name={`${itemInput.Id}`}
                        label={itemInput.Description}
                        validations={{ required: itemInput.Required }}
                        defaultValue={itemInput.Value}
                        error={!!formState.errors[`${itemInput.Id}`]}
                        helperText={formState.errors[`${itemInput.Id}`]?.message}
                        required={itemInput.Required}
                      />
                    );
                  case 'CLABE':
                    return (
                      <InputField
                        inputType="clabe"
                        control={control}
                        register={register}
                        name={`${itemInput.Id}`}
                        label={itemInput.Description}
                        validations={{ required: itemInput.Required }}
                        defaultValue={itemInput.Value}
                        error={!!formState.errors[`${itemInput.Id}`]}
                        helperText={formState.errors[`${itemInput.Id}`]?.message}
                        required={itemInput.Required}
                      />
                    );
                  case 'RFC':
                    return (
                      <InputField
                        inputType="rfc"
                        control={control}
                        register={register}
                        name={`${itemInput.Id}`}
                        label={itemInput.Description}
                        validations={{ required: itemInput.Required }}
                        defaultValue={itemInput.Value}
                        error={!!formState.errors[`${itemInput.Id}`]}
                        helperText={formState.errors[`${itemInput.Id}`]?.message}
                        required={itemInput.Required}
                      />
                    );
                  case 'CURP':
                    return (
                      <InputField
                        inputType="curp"
                        control={control}
                        register={register}
                        name={`${itemInput.Id}`}
                        label={itemInput.Description}
                        validations={{ required: itemInput.Required }}
                        defaultValue={itemInput.Value}
                        error={!!formState.errors[`${itemInput.Id}`]}
                        helperText={formState.errors[`${itemInput.Id}`]?.message}
                        required={itemInput.Required}
                      />
                    );
                  case 'NUMBER':
                    return (
                      <InputField
                        inputType="number"
                        control={control}
                        register={register}
                        name={`${itemInput.Id}`}
                        label={itemInput.Description}
                        validations={{ required: itemInput.Required }}
                        defaultValue={itemInput.Value}
                        error={!!formState.errors[`${itemInput.Id}`]}
                        helperText={formState.errors[`${itemInput.Id}`]?.message}
                        required={itemInput.Required}
                      />
                    );
                  case 'POSTALCODE':
                    return (
                      <InputField
                        inputType="PostalCode"
                        control={control}
                        register={register}
                        name={`${itemInput.Id}`}
                        label={itemInput.Description}
                        validations={{ required: itemInput.Required }}
                        defaultValue={itemInput.Value}
                        error={!!formState.errors[`${itemInput.Id}`]}
                        helperText={formState.errors[`${itemInput.Id}`]?.message}
                        required={itemInput.Required}
                      />
                    );
                  case 'PASSWORD':
                    return (
                      <InputField
                        inputType="password"
                        control={control}
                        register={register}
                        name={`${itemInput.Id}`}
                        label={itemInput.Description}
                        validations={{ required: itemInput.Required }}
                        defaultValue={itemInput.Value}
                        error={!!formState.errors[`${itemInput.Id}`]}
                        helperText={formState.errors[`${itemInput.Id}`]?.message}
                        required={itemInput.Required}
                        isPassword={true}
                      />
                    );
                  case 'PIN':
                    return (
                      <InputField
                        inputType="PIN"
                        control={control}
                        register={register}
                        name={`${itemInput.Id}`}
                        label={itemInput.Description}
                        validations={{ required: itemInput.Required }}
                        defaultValue={itemInput.Value}
                        error={!!formState.errors[`${itemInput.Id}`]}
                        helperText={formState.errors[`${itemInput.Id}`]?.message}
                        required={itemInput.Required}
                      />
                    );
                  case 'TEXTLETTER':
                    return (
                      <InputField
                        inputType="textLetter"
                        control={control}
                        register={register}
                        name={`${itemInput.Id}`}
                        label={itemInput.Description}
                        validations={{ required: true }}
                        defaultValue={itemInput.Value}
                        error={!!formState.errors[`${itemInput.Id}`]}
                        helperText={formState.errors[`${itemInput.Id}`]?.message}
                        required={itemInput.Required}
                        maxLength={itemInput.Length}
                      />
                    );
                  case 'ALPHANUMERIC':
                    return (
                      <InputField
                        inputType="alphanumeric"
                        control={control}
                        register={register}
                        name={`${itemInput.Id}`}
                        label={itemInput.Description}
                        validations={{ required: true }}
                        defaultValue={itemInput.Value}
                        error={!!formState.errors[`${itemInput.Id}`]}
                        helperText={formState.errors[`${itemInput.Id}`]?.message}
                        required={itemInput.Required}
                        maxLength={itemInput.Length}
                      />
                    );
                  default:
                    return (
                      <InputField
                        inputType="text"
                        control={control}
                        register={register}
                        name={`${itemInput.Id}`}
                        label={itemInput.Description}
                        validations={{ required: itemInput.Required }}
                        defaultValue={itemInput.Value}
                        error={!!formState.errors[`${itemInput.Id}`]}
                        helperText={formState.errors[`${itemInput.Id}`]?.message}
                        required={itemInput.Required}
                      />
                    );
                }
              })}
            </Box>
          )}
          {questions.length > 0 ? (
            <Grid container spacing={2} justifyContent="center" sx={{ mt: 1, mb: 3 }}>
              <Grid
                item
                xs={12}
                sm={props.handleCancel != undefined && props.handleCancel != null ? 6 : 8}
              >
                <Button
                  id={'btnConfirmPassword'}
                  fullWidth
                  variant="contained"
                  sx={{ height: 45, px: 10, borderRadius: '5px !important' }}
                  disabled={props.DisabledConfirm}
                  onClick={handleSubmit(props.handleConfirm)}
                >
                  {props.ConfirmButtonText === undefined || props.ConfirmButtonText === null
                    ? t('general_next_2')
                    : props.ConfirmButtonText}
                </Button>
              </Grid>
              {props.handleCancel != undefined && props.handleCancel != null ? (
                <Grid item xs={12} sm={6}>
                  <Button
                    id={'btnConfirmCancel'}
                    fullWidth
                    color="secondary"
                    variant="outlined"
                    sx={{ height: 45, px: 10, borderRadius: '5px !important' }}
                    disabled={props.DisabledCancel}
                    onClick={() => {
                      props.handleCancel();
                    }}
                  >
                    {props.CancelButtonText === undefined || props.CancelButtonText === null
                      ? t('general_cancel')
                      : props.CancelButtonText}
                  </Button>
                </Grid>
              ) : null}
            </Grid>
          ) : null}
        </Box>
      </LocalizationProvider>
    </FormProvider>
  );
};
